export * from './LoadingIcon';
//# sourceMappingURL=index.js.map